/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Zotero_Browser_Failed_Items_CountInputs */

const en_zotero_browser_failed_items_count = /** @type {(inputs: Zotero_Browser_Failed_Items_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`1 item failed — still selected, tap Import to retry`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} items failed — still selected, tap Import to retry`);
	return /** @type {LocalizedString} */ ("zotero_browser_failed_items_count");
};

const es_zotero_browser_failed_items_count = /** @type {(inputs: Zotero_Browser_Failed_Items_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Falló 1 elemento — sigue seleccionado, toca Importar para reintentar`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Fallaron ${i?.count} elementos — siguen seleccionados, toca Importar para reintentar`);
	return /** @type {LocalizedString} */ ("zotero_browser_failed_items_count");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "1 item failed — still selected, tap Import to retry" |
* | "other" | "{count} items failed — still selected, tap Import to retry" |
*
* @param {Zotero_Browser_Failed_Items_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_failed_items_count = /** @type {((inputs: Zotero_Browser_Failed_Items_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_Failed_Items_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_failed_items_count(inputs)
	return en_zotero_browser_failed_items_count(inputs)
});